export default {
  semantic: {
    surface: {
      0: '#ffffff',
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617',
    },
    primary: {
      50: '#e7e9ed',
      100: '#d0d2db',
      200: '#a0a6b6',
      300: '#717992',
      400: '#4c5263',
      500: '#282b34',
      600: '#20222a',
      700: '#181a1f',
      800: '#101115',
      900: '#08090a',
      950: '#040405',
    },
    blue: {
      50: '#e4e8f8',
      100: '#c9d1f0',
      200: '#93a3e1',
      300: '#5d75d2',
      400: '#334eb8',
      500: '#243782',
      600: '#1d2c68',
      700: '#16214e',
      800: '#0e1634',
      900: '#070b1a',
      950: '#04050d',
    },
    tangerine: {
      50: '#ffe9e2',
      100: '#ffd3c6',
      200: '#ffa88e',
      300: '#ff7c55',
      400: '#f55f37',
      500: '#e94e24',
      600: '#c83f1c',
      700: '#a63116',
      800: '#842510',
      900: '#6a1d0c',
      950: '#3e0f06',
    },
    mint: {
      50: '#e6f7f5',
      100: '#cdefea',
      200: '#9bdfd6',
      300: '#69cfc1',
      400: '#47b9ab',
      500: '#43aaa0',
      600: '#35867e',
      700: '#296862',
      800: '#1d4a46',
      900: '#13302d',
      950: '#0b1b1a',
    },
    sfsOrange: {
      50: '#fff6e5',
      100: '#ffebc2',
      200: '#ffd785',
      300: '#ffc147',
      400: '#f3b02d',
      500: '#eca935',
      600: '#c78d2b',
      700: '#a07322',
      800: '#7a5919',
      900: '#5f4613',
      950: '#322508',
    },
    anthracite: {
      500: '#2b2b34',
    },
  },
}
